import { useQuery } from 'react-query';
import { cacheKeys } from 'config';
import { reportsClient } from 'clients/reports/reportsClient';

export type Params = {
  id: string;
};

type Options = {
  enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useReport = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: report } = {}, status, error } = useQuery(
    [cacheKeys.reports.getReport, params],
    () => reportsClient.getReport(params.id),
    {
      enabled: options.enabled,
    },
  );

  return {
    status,
    error,
    report,
  };
};
